import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledTitleWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  &&& svg {
    transform: scale(0.75);
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    &&& svg {
      transform: scale(1);
    }
  }
`;

export const StyledTitle = styled.div`
  text-transform: uppercase;
  ${pickThemeFontStyles('12', '12', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '16', 'NORMAL')};
  }
`;

export const StyledDataList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const StyledDataListItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLabel = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.CHARCOAL};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('16', '24', 'NORMAL')};
  }
`;

export const StyledValue = styled.div`
  ${pickThemeFontStyles('18', '24', 'NORMAL')};
  color: ${COLORS.BLACK_PRIMARY};

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '24', 'BOLD')};
  }
`;
